import { ReactElement } from 'react';
import TableSummary, {
  TableSummaryProps,
} from '@casops/components/tables/table-summary/TableSummary';
import FilterSummary from '@casops/components/inputs/filter-summary/FilterSummary';
import { FilterProps } from '@casops/filters/types';

export interface CollectionSummaryProps extends TableSummaryProps {
  filterProps?: FilterProps;
}

export function CollectionSummary({
  modelName,
  secondaryModelName,
  countAll,
  apiResultLimit,
  filterProps,
}: CollectionSummaryProps): ReactElement {
  if (filterProps) {
    return (
      <FilterSummary
        {...filterProps}
        modelName={modelName}
        secondaryModelName={secondaryModelName}
      />
    );
  } else {
    return (
      <TableSummary
        modelName={modelName}
        countAll={countAll}
        secondaryModelName={secondaryModelName}
        apiResultLimit={apiResultLimit}
      />
    );
  }
}

export default CollectionSummary;
